/* eslint-disable */
import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Landingpage from './container/login/landingpage/index'
import Login from './container/login/Index';
import NotFound from './pages/Page404';
import DashboardApp from './pages/DashboardApp';
import UserLayout from './layouts/userLayout/UserLayout';
import Dashboard from './container/dashboard/Index';
import BeginCourse from './container/course/Index';
import CreateCourseTypes from './container/admin/courseDetails/CreateCourseTypes';
import CourseContent from './container/admin/courseDetails/CourseContent';
import { GetStarted } from './website/pages/GetStarted';
import { VerifyOtp } from './website/pages/VerifyOtp';
import CourseList from './container/admin/courseDetails/CourseList';
import ClientDetalis from './container/admin/clientDetails/Index';
import SubModuleDetails from './container/admin/courseDetails/SubModuleDetails';
import Account from './container/profile/Index';
import ClientUsers from './container/admin/users/ClientList';
import IndividualUsers from './container/admin/users/IndividualList';
import IndividualUsersView from './container/admin/users/ViewProfessionaldetails';
import ContentBank from './container/admin/users/ContentBank';
import UsersTrialTables from './container/admin/reports/userTrialTables/Index';
import UsersSubscribed from './container/admin/reports/userTrialTables/userSubscribedTables/index';
import SubscribedUsersNew from './container/admin/reports/subscribedUsersTable/Index';
import UserDetails from './container/admin/reports/subscribedUsersTable/userDetails/Index';
import ContentWriter from './container/admin/users/ContentCreaterList';
import ContentWriterDetails from './container/admin/users/Viewdetails';
import Feedback from './container/admin/feedback/Index';
import ResetPassword from './container/login/ResetPassword';
import ClientCourse from './container/clientAdmin/courses/Index';
import ClientAssessment from './container/clientAdmin/Assessments/index';
import UserTable from './container/clientAdmin/users/UserTable';
import ClientAccount from './container/clientAdmin/AccountProfile/Index';
import ClientAdminCourse from './container/clientAdmin/courseDetails/Index';
import ClientAdminAssessments from './container/clientAdmin/users/AssessmentDetails';
import UserCourseProgress from './container/admin/courseProgress/Index';
import SATReport from './container/admin/reports/SATReport';
import McqQuestion from './container/admin/courseDetails/McqQuestion';
import QuestionBank from './container/admin/courseDetails/QuestionBank';
import Settings from './container/admin/courseDetails/Settings';
import SettingViewPage from './container/admin/courseDetails/ConfigView';
import AddSetting from './container/admin/courseDetails/SettingCreatePage';
import Mcqmultipleupload from './container/admin/courseDetails/MultipleQuestionsUpload';
import ExcelUpload from './container/admin/courseDetails/UploadExcel';
import SATAssessment from './container/admin/courseDetails/SatQuestions';
import SATAssessmentTest from './container/admin/courseDetails/SatTest';
import SATAssessmentTestEdit from './container/admin/courseDetails/SatTestEdit';
import Sat from './container/admin/courseDetails/Sat';
import ADDNEET from './container/admin/courseDetails/Neet';
import NEETAssessment from './container/admin/courseDetails/NeetAssessment';
import EditNEET from './container/admin/courseDetails/NEETEdit';
import EditNEETAssessment from './container/admin/courseDetails/NeetAssessmentEdit';
import NEET from './container/admin/courseDetails/NEETMain';
import CLAT from './container/admin/courseDetails/CLATMain';
import AddCLAT from './container/admin/courseDetails/Assessmentscreation';
import ChatBotUpload from './container/admin/courseDetails/ChatBotUpload';
import UserProfile from './container/clientAdmin/users/UserProfile';
import LearnerProfile from './container/clientAdmin/users/learnerProfile/index';
import ClientReport from './container/admin/clientDetails/clientDetailsTabs/reports';
import UserCourseDetails from './container/users/course/UserCourseDetails';
import UserCourseList from './container/users/course/CourseList';
import SatList from './container/users/course/SatB2B';
import SkillIQ from './container/course/SkillIQ';
import GeneralAssessment from './container/course/generalAssessmentView';
import GeneralAssessmentMain from './container/generalAssessment/GeneralAssessmentMain';
import AssessmentCourseDetails from '../src/container/users/course/AssessmentCourseDetails';
import AssessmentOverview from '../src/container/users/course/AssessmentOverview';
import SatOverview from './container/users/Assessments/Assessmentsoverview';
import ChapterOverView from './container/users/course/SatChapterOverview';
import ChapterLevelSimulation from '../src/container/users/course/SatChapterTest';
import SATAnalysis from '../src/container/users/course/SATAnalysis';
import SATScoreOverview from '../src/container/admin/courseDetails/SatScoreOverview';
import SATScoreChapter from '../src/container/admin/courseDetails/SatScoreChapter';
import SatAssessmentMain from './container/users/course/SatAssessmentPage';
import TestBreak from './container/users/course/TestBreak';
import SatTimeoutPage from './container/users/course/TimeoutPage';
import PrePaymentPage from './container/users/course/PrePaymentPage';
import DashboardConfig from './container/admin/courseDetails/DashboardSettings.jsx'
import LoginPageConfig from './container/admin/courseDetails/Loginpageconfig'
import EbookCreator from './container/clientAdmin/EBookCreator'
import EBooksList from './container/clientAdmin/EBooksList'


import TextEditor from './components/TextEditor';
import { CourseAnalyticDetails } from './container/clientAdmin/Analytics/CourseAnalytics';
import CourseAnalytics from './container/clientAdmin/Analytics/Index';
import { CoursesAnalyticsTab } from './container/clientAdmin/Analytics/CoursesAnalyticsTab';
import { CaseStudiesTab } from './container/clientAdmin/Analytics/CaseStudiesTab';
import ClientDashboard from './container/clientAdmin/dashboard/Index';
import ManagerDashboard from './container/clientAdmin/dashboard/ManagerDashboard';
import DepartmentsAndTeams from './container/clientAdmin/departments/Index';
import GlobalCatalog from './container/clientAdmin/catalog/Index';
import ClientContentBank from './container/clientAdmin/contentBank/Index';
import ReportsPage from './container/clientAdmin/reports/Index';
import AuditLogPage from './container/clientAdmin/auditLog/Index';
import TenantUsers from './container/clientAdmin/users/TenantUsers';
import ScheduleList from './container/clientAdmin/users/LearnerScheduledetails'
import UsersRoles from './container/clientAdmin/usersRoles/Index';
import Subscriptions from './container/admin/subscriptions/Index';
import CreateAssessmentPlan from './container/admin/subscriptions/CreateAssessmentPlan';
import CreateSingleCoursePlan from './container/admin/subscriptions/CreateSingleCoursePlan';
import CreateBundlePlan from './container/admin/subscriptions/CreateBundlePlan';
import CreateB2BPlan from './container/admin/subscriptions/CreateB2BPlan';
import CreateEbooksPlan from './container/admin/subscriptions/CreateEbooksPlan';
import PlanDetail from './container/admin/subscriptions/PlanDetail';
import WebsiteLayout from './layouts/website/websiteLayout';
import WebsiteLayoutUser from './layouts/website/UserLayout';
import EmailVerification from './website/pages/EmailVerification';
import BundleDetails from './container/users/course/BundleDetails';
import NEETAssessmentDetails from './container/users/course/NEETAssessmentDetails';
import NeetSimulation from './container/generalAssessment/NEETExamSimulation';
import EBookReader from './container/course/Ebook';
import EBookStudentList from './container/course/EBookStudentList';
import EBookDetails from './container/course/EBookDetails';
import CaseStudyIQTest from './container/users/CaseStudyIQTest';
import { SuccessPage } from './website/pages/SuccessPage';
import ProtectedRoute from './components/ProtectedRoutes';
import EndUserDashboard from './container/users/course/Dashboard/index';
import ContentCreatorDashboard from './container/common/Dashboard/index';
import Sources from './container/common/Source/index';
import Questions from './container/common/Questions/index';
import CreateQuestions from './container/common/Questions/form';
import Assessments from './container/common/Assessments/index';
import BulkUpload from './container/common/BulkUpload/index';
import AssessmentCreate from './container/common/Assessments/form';
import SourceChapters from './container/common/Source/formSourceChapters';
import ChapterQuestions from './container/common/Source/formChapterQuestions';
import BillingModel from './container/clientAdmin/billing';
import ExchangeOTT from './container/widget/ExchangeOTT';
import UserSubscriptions from './container/authUser/UserSubscriptions';
import UserSupport from './container/authUser/UserSupport';
import SimulationPreview from './container/course/SimulationPreview';
import SubscriptionPlan from '../src/container/users/course/Dashboard/components/AssessmentsView/sections/Subscriptionplan';
import PlatformConfig from './container/common/PlatformConfig/index';
import Announcement from './container/clientAdmin/announcement/index';
import ProctoringMonitor from './container/clientAdmin/proctoring/Index';
import UserAnnouncements from './container/users/Announcements/Index';
import DatabaseVisualizer from './container/admin/database/Index';
import ExportData from './container/common/Source/Exportdata'
import AnalyticsDashboard from './container/admin/analytics/AnalyticsDashboard';
import EmailTracking from './container/admin/emailTracking/Index';
import MailTemplates from './container/admin/mailTemplates/Index';
import Roles from './container/admin/roles/Index';
import AdminUserList from './container/admin/users/AdminUserList';
import UserDetailsStatus from './container/crisisCommunication/users'
import SubscribedUsers from './container/crisisCommunication/subscribedusers'

function ContentBankGuard({ children }) {
  const featureToggleMode = useSelector((state) => state.userInfo?.featureToggleMode);
  if (featureToggleMode && featureToggleMode !== 'FULL_CREATOR') {
    return <Navigate to="/app/catalog" replace />;
  }
  return children;
}


const LEGACY_ROLE_LAYOUT = {
  SUPER_ADMIN: 'ADMIN',
  CLIENT_ADMIN: 'CLIENT',
  MANAGER: 'CLIENT',
  CONTENT_WRITER: 'CONTENT',
  AUTH_USER: 'USER',
  USER_DTC: 'DIRECT_USER',
};

function resolveLayout(roleLayout, userRole) {
  if (roleLayout) return roleLayout;
  // Unknown roles previously fell through to the admin tree's `client` branch.
  return LEGACY_ROLE_LAYOUT[userRole] || 'CLIENT';
}

export default function Router() {

  const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
  // role_lk.layout / default_route / allowed_pages, delivered by /authenticate/loginInfo.
  // Layout used to be inferred from hardcoded role checks; every one of them ended in
  // an `else`, so a new role silently inherited whichever branch fell through last.
  const roleLayout = useSelector((state) => state.userInfo && state.userInfo.layout);
  const defaultRoute = useSelector((state) => state.userInfo && state.userInfo.defaultRoute);
  const allowedPages = useSelector((state) => state.userInfo && state.userInfo.allowedPages);

  // Falls back to the legacy role mapping so sessions issued before this shipped,
  // and any role without a layout set, keep behaving exactly as they did.
  const layout = resolveLayout(roleLayout, userRole);

  if (userRole === undefined || userRole === null) {
    const unauthenticatedRoutes = [
      {
        path: '/',
        element: <LogoOnlyLayout />,
        children: [
          { path: '/', element: <Navigate to="/login" /> },
          //  { path: '/', element: <Landingpage /> },
          { path: 'login', element: <Login /> },
          { path: 'reset-password', element: <Login resetPasswordMode="forgot" /> },
          { path: 'reset-password/sent', element: <Login resetPasswordMode="sent" /> },
          { path: 'reset-password-now/:token', element: <Login resetPasswordMode="verify" /> },
          { path: 'forgot-password', element: <ResetPassword /> },
          { path: 'mailverification', element: <EmailVerification /> },
          { path: 'exchange-ott', element: <ExchangeOTT /> },
          { path: '404', element: <NotFound /> },
          { path: '*', element: <Navigate to="/login" /> },
        ],
      },
      {
        path: '/',
        element: <WebsiteLayout />,
        children: [
          { path: '/', element: <Login /> },
          { path: 'sign-up', element: <GetStarted /> },
          { path: 'verify-otp', element: <VerifyOtp /> },
          { path: 'dashboard', element: <VerifyOtp /> },
        ],
      },
      { path: '/app/*', element: <Navigate to="/login" /> },
      { path: '/auth/*', element: <Navigate to="/login" /> },
    ];
    return useRoutes(unauthenticatedRoutes);
  }

  const CheckRoute = () => {
    const validRoutes = [...directUser, ...admin, ...user, ...client];
    const currentPath = window.location.pathname;
    if (currentPath.includes('/auth/')) {
      const navissue = validRoutes.filter((data) => data.path === currentPath.replace('/auth/', ''));
      if (navissue && navissue?.length > 0) {
        return <Navigate to="/login" />;
      }
      return <Navigate to="/404" />;
    }
    const navissue = validRoutes.filter((data) => data.path === currentPath.replace('/app/', ''));
    if (navissue && navissue?.length > 0) {
      return <Navigate to="/login" />;
    }
    return <Navigate to="/404" />;
  };

  const admin = [
    { path: 'dashboard', element: <DashboardApp /> },
    { path: 'sources', element: <Sources /> },
    { path: 'questions', element: <Questions /> },
    { path: 'question-create', element: <CreateQuestions /> },
    { path: 'question-edit/:id', element: <CreateQuestions /> },
    { path: 'assessments', element: <Assessments /> },
    { path: 'bulkUpload', element: <BulkUpload /> },
    { path: 'platformconfig', element: <PlatformConfig /> },
    { path: 'source-chapters/:sourceId', element: <SourceChapters /> },
    { path: 'chapter-questions/:chapterId', element: <ChapterQuestions /> },
    { path: 'assessmentCreate', element: <AssessmentCreate /> },
    { path: 'general-test', element: <GeneralAssessment /> },
    { path: 'TextEditor', element: <TextEditor /> },
    { path: 'ebook-list', element: <EBooksList /> },
    { path: 'ebook-creator', element: <EbookCreator /> },
    { path: 'ebook-creator/:id', element: <EbookCreator /> },
    { path: 'course', element: <CourseList /> },
    { path: 'course-type', element: <CreateCourseTypes /> },
    { path: 'course-content', element: <CourseContent /> },
    { path: 'submodules', element: <SubModuleDetails /> },
    { path: 'client-users', element: <ClientUsers /> },
    { path: 'individual-users', element: <IndividualUsers /> },
    { path: 'individual-usersview', element: <IndividualUsersView /> },
    { path: 'content-bank', element: <ContentBank /> },
    { path: 'trial-users', element: <UsersTrialTables /> },
    { path: 'subscribed-users-new', element: <SubscribedUsersNew /> },
    { path: 'user-details', element: <UserDetails /> },
    { path: 'simulation-preview', element: <SimulationPreview /> },
    { path: 'skilliq-test', element: <SkillIQ /> },
    { path: 'content-writer-details', element: <ContentWriter /> },
    { path: 'content-writer-detailsview', element: <ContentWriterDetails /> },
    { path: 'client-details', element: <ClientDetalis /> },
    { path: 'subscription', element: <Subscriptions /> },
    { path: 'subscription/create/assessment', element: <CreateAssessmentPlan /> },
    { path: 'subscription/create/single', element: <CreateSingleCoursePlan /> },
    { path: 'subscription/create/bundle', element: <CreateBundlePlan /> },
    { path: 'subscription/create/b2b', element: <CreateB2BPlan /> },
    { path: 'subscription/create/ebooks', element: <CreateEbooksPlan /> },
    { path: 'subscription/:planType/:id', element: <PlanDetail /> },
    { path: 'account', element: <Account /> },
    { path: 'dashboardconfig', element: <DashboardConfig/> },
    { path: 'loginPageConfig', element: <LoginPageConfig/> },
    { path: 'feedback', element: <Feedback /> },
    { path: 'client-course', element: <ClientCourse /> },
    { path: 'client-Admin-course', element: <ClientAdminCourse /> },
    { path: 'client-Admin-assessment', element: <ClientAdminAssessments /> },
    { path: 'course-progress', element: <UserCourseProgress /> },
    { path: 'sat-report', element: <SATReport /> },
    { path: 'question-details', element: <McqQuestion /> },
    { path: 'question-book', element: <QuestionBank /> },
    { path: 'satassessmentquestion', element: <SATAssessment /> },
    { path: 'satassessment', element: <SATAssessmentTest /> },
    { path: 'editSatassessment', element: <SATAssessmentTestEdit /> },
    { path: 'satpage', element: <Sat /> },
    { path: 'CLAT', element: <CLAT /> },
    { path: 'clatmain', element: <AddCLAT /> },
    { path: 'ChatBotUpload', element: <ChatBotUpload /> },
    { path: 'Mcqmultipleupload', element: <Mcqmultipleupload /> },
    { path: 'ExcelUpload', element: <ExcelUpload /> },
    { path: 'NEET', element: <NEET /> },
    { path: 'ADDNEET', element: <ADDNEET /> },
    { path: 'ADDNEETAssessment', element: <NEETAssessment /> },
    { path: 'EditNEET', element: <EditNEET /> },
    { path: 'EditNEETAssessment', element: <EditNEETAssessment /> },
    { path: 'settings', element: <Settings /> },
    { path: 'view-Settings', element: <SettingViewPage /> },
    { path: 'add-Settings', element: <AddSetting /> },
    { path: 'client-reports', element: <ClientReport /> },
    { path: 'database', element: <DatabaseVisualizer /> },
    { path: 'analytics', element: <AnalyticsDashboard /> },
    { path: 'email-tracking', element: <EmailTracking /> },
    { path: 'email-templates', element: <MailTemplates /> },
    { path: 'roles', element: <Roles /> },
    { path: 'admin-users', element: <AdminUserList /> },
    { path: 'crisis-users', element: <UserDetailsStatus /> },
    { path: 'subscribed-users', element: <SubscribedUsers /> },
    
  ];

  const client = [
    { path: 'dashboard', element: userRole === 'MANAGER' ? <ManagerDashboard /> : <ClientDashboard /> },
    { path: 'users', element: <UserTable /> },
    { path: 'UserProfile', element: <UserProfile /> },
    { path: 'learner-profile', element: <LearnerProfile /> },
    { path: 'user-table', element: <UserTable /> },
    { path: 'course', element: <ClientCourse /> },
    { path: 'client-course-content', element: <ClientAdminCourse /> },
    { path: 'client-assessment-content', element: <ClientAdminAssessments /> },
    { path: 'course-content', element: <CourseContent /> },
    { path: 'simulation-preview', element: <SimulationPreview /> },
    { path: 'account', element: <ClientAccount /> },
    { path: 'analytics', element: <CourseAnalytics /> },
    { path: 'analytics-details', element: <CourseAnalyticDetails /> },
    { path: 'courses-analyticstab', element: <CoursesAnalyticsTab /> },
    { path: 'case-studiestab', element: <CaseStudiesTab /> },
    { path: 'assessments', element: <ClientAssessment /> },
    { path: 'org', element: <DepartmentsAndTeams /> },
    { path: 'announcement', element: userRole === 'MANAGER' ? <UserAnnouncements /> : <Announcement /> },
    { path: 'proctoring', element: <ProctoringMonitor /> },
    { path: 'learners', element: <TenantUsers /> },
    { path: 'scheduledetails', element: <ScheduleList /> },
    { path: 'catalog', element: <GlobalCatalog /> },
    { path: 'content-bank', element: <ContentBankGuard><ClientContentBank /></ContentBankGuard> },
    { path: 'reports', element: <ReportsPage /> },
    { path: 'audit-log', element: <AuditLogPage /> },
    { path: 'users-roles', element: <UsersRoles /> },
    { path: 'billing', element: <BillingModel /> },
  ];

  const user = [
    { path: 'course', element: <UserCourseList /> },
    { path: 'sat', element: <SatList /> },
    { path: 'course-details/:id/:planId?', element: <UserCourseDetails /> },
    { path: 'course-simulation', element: <BeginCourse /> },
    { path: 'skilliq-test', element: <SkillIQ /> },
    { path: 'case-studyiq-test', element: <CaseStudyIQTest /> },
    { path: 'account', element: <Account /> },
    { path: 'AssessmentCourseDetails', element: <AssessmentCourseDetails /> },
    { path: 'AssessmentOverview', element: <AssessmentOverview /> },
    { path: 'assessment/:name/:assessmentId', element: <SatOverview /> },
    { path: 'ChapterOverView', element: <ChapterOverView /> },
    { path: 'ChapterLevelSimulation', element: <ChapterLevelSimulation /> },
    { path: 'PrePaymentPage', element: <PrePaymentPage /> },
    { path: 'support', element: <UserSupport /> },
    { path: 'sat-chapter-test-report', element: <SATScoreChapter /> },
    { path: 'sat-test-report', element: <SATScoreOverview /> },
    { path: 'SatAssessmentMain', element: <SatAssessmentMain /> },
    { path: 'TestBreak', element: <TestBreak /> },
    { path: 'SatTimeoutPage', element: <SatTimeoutPage /> },
    { path: 'SATAnalysis', element: <SATAnalysis /> },
    { path: 'NEETAssessmentDetails', element: <NEETAssessmentDetails /> },
    { path: 'NeetSimulation', element: <NeetSimulation /> },
    { path: 'e-books', element: <EBookStudentList /> },
    { path: 'e-book/:ebookId', element: <EBookReader /> },
    { path: 'e-book-detail/:ebookId', element: <EBookDetails /> },
    { path: 'announcements', element: <UserAnnouncements /> },

  ];

  const directUser = [
    { path: 'my-courses', element: <UserCourseList /> },
    { path: 'sat', element: <SatList /> },
    { path: 'course-details/:id/:planId?', element: <UserCourseDetails /> },
    { path: 'skilliq-test', element: <SkillIQ /> },
    { path: 'course-simulation', element: <BeginCourse /> },
    { path: 'account', element: <Account /> },
    { path: 'subscribe', element: <EndUserDashboard /> },
    { path: 'plans', element: <SubscriptionPlan /> },
    { path: 'success-page', element: <SuccessPage /> },
    { path: 'failure-page', element: <SuccessPage /> },
    { path: 'case-studyiq-test', element: <CaseStudyIQTest /> },
    { path: 'subscriptions', element: <UserSubscriptions /> },
    { path: 'support', element: <UserSupport /> },
    { path: 'bundledetails', element: <BundleDetails /> },
    { path: 'AssessmentCourseDetails', element: <AssessmentCourseDetails /> },
    { path: 'AssessmentOverview', element: <AssessmentOverview /> },
    { path: 'assessment/:name/:assessmentId', element: <SatOverview /> },
    { path: 'sat-chapter-test-report', element: <SATScoreChapter /> },
    { path: 'sat-test-report', element: <SATScoreOverview /> },
    { path: 'ChapterOverView', element: <ChapterOverView /> },
    { path: 'ChapterLevelSimulation', element: <ChapterLevelSimulation /> },
    { path: 'PrePaymentPage', element: <PrePaymentPage /> },
    { path: 'SATAnalysis', element: <SATAnalysis /> },
    { path: 'SatAssessmentMain', element: <SatAssessmentMain /> },
    { path: 'TestBreak', element: <TestBreak /> },
    { path: 'SatTimeoutPage', element: <SatTimeoutPage /> },
    { path: 'TextEditor', element: <TextEditor /> },
    { path: 'NEETAssessmentDetails', element: <NEETAssessmentDetails /> },
    { path: 'NeetSimulation', element: <NeetSimulation /> },
    // DTC users open the E-Books library as a view inside /auth/subscribe, not a
    // separate URL — only the detail and reader pages are routed here.
    { path: 'e-book/:ebookId', element: <EBookReader /> },
    { path: 'e-book-detail/:ebookId', element: <EBookDetails /> },
  ];

  const contentWriter = [
    { path: 'dashboard', element: <ContentCreatorDashboard /> },
    { path: 'sources', element: <Sources /> },
    { path: 'questions', element: <Questions /> },
    { path: 'question-create', element: <CreateQuestions /> },
    { path: 'question-edit/:id', element: <CreateQuestions /> },
    { path: 'assessments', element: <Assessments /> },
    { path: 'platformconfig', element: <PlatformConfig /> },
    { path: 'bulkUpload', element: <BulkUpload /> },
    { path: 'source-chapters/:sourceId', element: <SourceChapters /> },
    { path: 'exportdata', element: <ExportData /> },
    { path: 'chapter-questions/:chapterId', element: <ChapterQuestions /> },
    { path: 'assessmentCreate', element: <AssessmentCreate /> },
    { path: 'general-test', element: <GeneralAssessment /> },
    { path: 'TextEditor', element: <TextEditor /> },
    { path: 'ebook-list', element: <EBooksList /> },
    { path: 'ebook-creator', element: <EbookCreator /> },
    { path: 'ebook-creator/:id', element: <EbookCreator /> },
    { path: 'course', element: <CourseList /> },
    { path: 'course-type', element: <CreateCourseTypes /> },
    { path: 'course-content', element: <CourseContent /> },
    { path: 'submodules', element: <SubModuleDetails /> },
    { path: 'simulation-preview', element: <SimulationPreview /> },
    { path: 'account', element: <Account /> },
    { path: 'skilliq-test', element: <SkillIQ /> },
    { path: 'question-details', element: <McqQuestion /> },
    { path: 'question-book', element: <QuestionBank /> },
    { path: 'Mcqmultipleupload', element: <Mcqmultipleupload /> },
    { path: 'ExcelUpload', element: <ExcelUpload /> },
    { path: 'NEET', element: <NEET /> },
    { path: 'ADDNEET', element: <ADDNEET /> },
    { path: 'ADDNEETAssessment', element: <NEETAssessment /> },
    { path: 'EditNEET', element: <EditNEET /> },
    { path: 'EditNEETAssessment', element: <EditNEETAssessment /> },
    { path: 'ChatBotUpload', element: <ChatBotUpload /> },
    { path: 'settings', element: <Settings /> },
    { path: 'view-Settings', element: <SettingViewPage /> },
    { path: 'satassessmentquestion', element: <SATAssessment /> },
    { path: 'satassessment', element: <SATAssessmentTest /> },
    { path: 'editSatassessment', element: <SATAssessmentTestEdit /> },
    { path: 'satpage', element: <Sat /> },
    { path: 'CLAT', element: <CLAT /> },
    { path: 'clatmain', element: <AddCLAT /> },
  ];

  const directUserPath = [
    { path: '/exchange-ott', element: <ExchangeOTT /> },
    {
      path: '/auth',
      element: window.location.pathname !== '/auth/SatAssessmentMain' ? <WebsiteLayoutUser /> : null,
      children: userRole && userRole === 'USER_DTC' ? directUser : [{ path: '*', element: <NotFound /> }],
    },
    {
      path: '/auth',
      element: window.location.pathname !== '/auth/TestBreak' ? <WebsiteLayoutUser /> : null,
      children: userRole && userRole === 'USER_DTC' ? directUser : [{ path: '*', element: <NotFound /> }],
    },
    {
      path: '/auth',
      element: window.location.pathname !== '/auth/TimeoutPage' ? <WebsiteLayoutUser /> : null,
      children: userRole && userRole === 'USER_DTC' ? directUser : [{ path: '*', element: <NotFound /> }],
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        // { path: '/', element: <Navigate to="/login" /> },
         { path: '/', element: <Login /> },
        { path: 'login', element: <Login /> },
        { path: 'reset-password', element: <Login resetPasswordMode="forgot" /> },
        { path: 'reset-password/sent', element: <Login resetPasswordMode="sent" /> },
        { path: 'reset-password-now/:token', element: <Login resetPasswordMode="verify" /> },
        { path: 'forgot-password', element: <ResetPassword /> },
        { path: 'mailverification', element: <EmailVerification /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <CheckRoute /> },
      ],
    },
    {
      path: '/',
      element: <WebsiteLayout />,
      children: [
        { path: '/', element: <Login /> },
          { path: 'sign-up', element: <GetStarted /> },
          { path: 'verify-otp', element: <VerifyOtp /> },
          { path: 'dashboard', element: <VerifyOtp /> },
        ],
    },
    { path: '*', element: <CheckRoute /> },
  ];

  // allowed_pages restricts which of the admin pages a role may open. null/empty
  // means no restriction, so SUPER_ADMIN and every legacy role keep the full set.
  // Blocked paths redirect to the role's default route rather than 404ing, so a
  // stale bookmark lands somewhere useful.
  const allowedSet = Array.isArray(allowedPages) && allowedPages.length
    ? new Set(allowedPages.map((p) => String(p).replace(/^\/app\//, '')))
    : null;

  // The landing target MUST itself be reachable. If a role's default_route is not
  // in its allowed_pages, redirecting blocked paths to it would render a <Navigate>
  // that immediately redirects to itself - an infinite redirect loop, which in turn
  // re-mounts the shell and re-fires its requests on every hop. Fall back to the
  // first allowed page, and if nothing is allowed, do not guard at all.
  const preferredLanding = (defaultRoute || '/app/dashboard').replace(/^\/app\//, '');
  const landingPath = !allowedSet || allowedSet.has(preferredLanding)
    ? preferredLanding
    : [...allowedSet][0];
  const landing = landingPath ? `/app/${landingPath}` : null;

  // Applies to whichever page set this layout renders, not just the admin one,
  // so a restricted CLIENT or CONTENT role cannot reach a blocked page by typing
  // its URL - the sidebar filter alone would only hide it.
  const guardRoutes = (routes) => (
    allowedSet && landing
      ? routes.map((route) =>
          allowedSet.has(route.path) || route.path === '*' || route.path === landingPath
            ? route
            : { ...route, element: <Navigate to={landing} replace /> }
        )
      : routes
  );

  const adminPath = [
    {
      path: '/app',
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: guardRoutes(layout === 'ADMIN' ? admin : client),
    },
    {
      path: '/',
      element: <WebsiteLayout />,
      children: [
        { path: '/', element: <Navigate to="/login" /> },
        // { path: '/', element: <Landingpage /> },
        { path: 'login', element: <Login /> },
        { path: 'reset-password', element: <Login resetPasswordMode="forgot" /> },
        { path: 'reset-password/sent', element: <Login resetPasswordMode="sent" /> },
        { path: 'reset-password-now/:token', element: <Login resetPasswordMode="verify" /> },
        { path: 'forgot-password', element: <ResetPassword /> },
        { path: 'mailverification', element: <EmailVerification /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <CheckRoute /> },
      ],
    },
    {
      path: '/',
      element: <WebsiteLayout />,
      children: [
        { path: '/', element: <Login /> },
          { path: 'sign-up', element: <GetStarted /> },
          { path: 'verify-otp', element: <VerifyOtp /> },
          { path: 'dashboard', element: <VerifyOtp /> },
        ],
    },
    { path: '*', element: <CheckRoute /> },
  ];

  const userPath = [
    { path: '/exchange-ott', element: <ExchangeOTT /> },
    {
      path: '/app',
      element: (
        <ProtectedRoute>
          {layout === 'CONTENT' ? <DashboardLayout /> : <UserLayout />}
        </ProtectedRoute>
      ),
      children: guardRoutes(layout === 'CONTENT' ? contentWriter : user),
    },
    {
      path: '/',
      element: <WebsiteLayout />,
      children: [
        { path: '/', element: <Login /> },
        { path: 'login', element: <Login /> },
        { path: 'reset-password', element: <Login resetPasswordMode="forgot" /> },
        { path: 'reset-password/sent', element: <Login resetPasswordMode="sent" /> },
        { path: 'reset-password-now/:token', element: <Login resetPasswordMode="verify" /> },
        { path: 'forgot-password', element: <ResetPassword /> },
        { path: 'mailverification', element: <EmailVerification /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <CheckRoute /> },
      ],
    },
    {
      path: '/',
      element: <WebsiteLayout />,
      children: [
        { path: '/', element: <Login /> },
          { path: 'sign-up', element: <GetStarted /> },
          { path: 'verify-otp', element: <VerifyOtp /> },
          { path: 'dashboard', element: <VerifyOtp /> },
        ],
    },
    { path: '*', element: <CheckRoute /> },
  ];

  let routingDetails = null;

  if (layout === 'DIRECT_USER') {
    routingDetails = useRoutes(directUserPath);
  } else {
    routingDetails = useRoutes(layout === 'USER' || layout === 'CONTENT' ? userPath : adminPath);
  }

  return routingDetails;
}